module.exports = __webpack_public_path__ + "static/img/20-0827-cover.52a3e96.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/20-0827-cover.jpeg
// module id = YXnB
// module chunks = 0